import { Outlet, createFileRoute, useRouterState } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { MaintenanceViewPage } from "@/pages/dashboard/maintenance/view";

/**
 * Maintenance detail. `$id/edit` is a child of this route — render `<Outlet />`
 * when editing so the form mounts instead of this view.
 */
export const Route = createFileRoute("/_main/dashboard/maintenance/$id")({
  component: () => (
    <RequirePermission action="maintenance.read">
      <MaintenanceIdLayout />
    </RequirePermission>
  ),
});

function MaintenanceIdLayout() {
  const showingChild = useRouterState({
    select: (state) => state.matches.some((match) => match.routeId.endsWith("/edit")),
  });
  if (showingChild) return <Outlet />;
  return <MaintenanceViewPage />;
}
